import {Controller} from '@stimulus/core'
import HSUnfold from '../../../../../vendor/front/vendor/hs-unfold/src/js/hs-unfold'
import {isPreview} from "../../support";

// data-controller='hs--unfold'
// data-hs-unfold-options='{}' https://htmlstream.com/preview/front-v3.2.2/documentation/unfold.html#methods

export default class extends Controller {
  connect() {
    if (isPreview()) {
      return false
    }

    new HSUnfold(this.element).init()

    return true
  }
}
